/** @jsxImportSource @emotion/react */
import { memo } from "react";

// CSS読み込み
import { blueButton, blueButton_inactive } from "assets/css/stylesCss";

/**
 * アクティブで青、非活性でグレーになるボタン
 * @param {Object} customCss CSS変更用オブジェクト
 * @param {Boolean} isActive ボタンが活性か否か
 * @param {Function} fn - ボタン押下時の挙動
 * childrenには要素内の文字列が自動的に入る
 */
const NavigateButton = memo(({ customCss, isActive, fn, children }) => {
  return (
    <button
      css={[isActive ? blueButton : blueButton_inactive, customCss]}
      disabled={!isActive}
      onClick={fn}
    >
      {children}
    </button>
  );
});

export default NavigateButton;
